/**
 * Submit or edit a community recipe — full-page route (edit) or legacy /new path.
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CommunityRecipesPageShell } from './CommunityRecipesPageShell';
import { CommunityRecipeFormPanel } from './CommunityRecipeFormPanel';
import './camp-essentials-shell.css';
import './camp-recipes-shell.css';

export function CommunityRecipeCreate() {
  const navigate = useNavigate();
  const { id: routeId } = useParams();
  const editId = routeId && /^\d+$/.test(String(routeId)) ? Number(routeId) : null;
  const isEdit = editId != null;

  return (
    <CommunityRecipesPageShell
      title={isEdit ? 'Edit recipe' : 'Submit a recipe'}
      subtitle="Share with the community"
      panelClassName="camp-recipes-page__panel--form camp-recipes-page__panel--submit"
      testId="camp-recipe-form"
    >
      <CommunityRecipeFormPanel
        editId={editId}
        onClose={() =>
          navigate(
            isEdit ? `/camp-essentials/recipes/${editId}` : '/camp-essentials/recipes',
          )
        }
        onSuccess={(recipeId) =>
          navigate(`/camp-essentials/recipes/${recipeId}`, { replace: true })
        }
      />
    </CommunityRecipesPageShell>
  );
}
